export default __webpack_public_path__ + "static/media/bonfida.cfb4006c.png";